import { Endpoint } from '@philips-emr/hpms-stipulator-commons';
import { PDFViewerAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import { PdfViewerAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.PDF_VIEWER })
export default class PDFViewerController extends BaseController {

  @OnMount(Aliases.PDF_VIEWER_0)
  onMountPdf(event: MountEvent): void {

    const api = event.target as PDFViewerAPI;
    const { src } = this.context.getBulkData();
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();
    const encode = new Buffer(src as string).toString('base64');
    api.setSrc(Endpoint.GET.REPORT_BY_PATH.replace(':nrSeqContrato', nrSeqContrato as string).replace(':path', encode));
  }
}
